/**
 * @desc 用户订单记录
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.UserOrderRecord,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.GeneralHttpResponse<number>>(
    `/storeapi/api/v3/user/order`,
    {
      data,
      method: 'post',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<number>;
export default req;
